import { RouteRecordRaw, RouteLocation } from 'vue-router'
import SectionsChildRoutes from '@/router/sections'
import exportsChildRoutes from '@/router/exports'
import projectParamAssessmentRoutes from '@/router/project-param-assessments'
import projectGeojsonRoutes from '@/router/project-geojson'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'sections',
    name: 'control-panel.sections',
    component: () => import('@/views/control-panel/projects/project/Sections.vue'),
    meta: { title: 'Alle deelprojecten' },
    redirect: (to: RouteLocation) => ({ name: 'map.sections', params: to.params }),
    children: SectionsChildRoutes
  },
  {
    path: 'downloads',
    name: 'control-panel.downloads',
    component: () => import('@/views/control-panel/projects/project/Exports.vue'),
    meta: { title: 'Alle exports' },
    redirect: (to: RouteLocation) => ({ name: 'control-panel.downloads.list', params: to.params }),
    children: exportsChildRoutes
  },
  {
    path: 'edit',
    name: 'control-panel.project.edit',
    component: () => import('@/views/control-panel/projects/project/Edit.vue'),
  },
  {
    path: 'param-assessments',
    name: 'project.param-assessments',
    component: () => import('@/views/control-panel/projects/project/ParamAssessments.vue'),
    redirect: () => ({ name: 'project.param-assessments.list' }),
    children: projectParamAssessmentRoutes
  },
  {
    path: 'geojson',
    name: 'project.geojson',
    component: () => import('@/views/control-panel/projects/project/GeoJson.vue'),
    redirect: () => ({ name: 'project.geojson.list' }),
    children: projectGeojsonRoutes
  }
]

export default routes
